export class PipeGroupModel {
    _id: string;
    id: number;
    name: string;
    description: string;
    code: string;

    constructor(_id = null,
        id = null,
        name = '',
        description = '',
        code = '') {
            this._id = _id;
            this.id = id;
            this.name = name;
            this.description = description;
            this.code = code;
    }
}
